export const resolveIconText = (variant) => {
    const [iconSizeValue, typeValue] = variant.split('--');
    return {
        iconSize: iconSizeValue,
        type: typeValue,
    };
};
export const ICON_TEXT_VARIANTS = [
    'xsmall--small',
    'xsmall--regular',
    'xsmall--heading6',
    'xsmall--heading7',
    'xsmall--vrm-xsmall',
    'small--regular',
    'small--large',
    'small--heading3',
    'small--heading5',
    'small--heading6',
    'small--vrm-small',
    'medium--heading2',
    'medium--heading3',
    'medium--vrm-regular',
    'large--vrm-large',
];
